<template>
  <div id="app">
    <div class="wrapper">
      <va-navibar></va-navibar>
      <va-slider ></va-slider>
      <va-content-wrap></va-content-wrap>
    </div>
  </div>
</template>

<script>
import VANaviBar from './Header.vue'
import VASlider from './Sidemenu.vue'
import VAContentWrap from './ContentWrap'
// import Modal from './components/Modal.vue'
// import slideMenuItems from '../../lib/slideMenuItems'

export default {
  name: 'app',
  data () {
    return {
      // slideMenuItems: slideMenuItems
    }
  },
  created () {
  },
  components: {
    'va-navibar': VANaviBar,
    'va-slider': VASlider,
    'va-content-wrap': VAContentWrap,
  }
}
</script>

<style>

</style>
